export default __webpack_public_path__ + "static/media/brokerage_light.647d23ad.png";